<template>
  <component :is="component" :tabIndex="tabIndex" :data="data"/>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import iframe from '~/components/iframe.vue';
// eslint-disable-next-line import/no-unresolved
import desktop from '~/components/desktop/vssport.vue';

export default {
    extends: iframe,
    components: {
        desktop
    },
    head() {
        return {};
    },
    data() {
        return {
            tabIndex: this.$getRoute(this.$route).path,
            data: {}
        };
    },
    methods: {
    },
    mounted() {
    }
    // async asyncData({ app, store }) {
    //     const res = await app.$urlApi.getMaintenance();
    //     if (res.status === 'OK' && res.data.enable) {
    //         store.dispatch('updateMaintenance', res.data);
    //     }
    // }
};
</script>
